import { call, select } from 'redux-saga/effects';
import { selectorAuthUserId } from '../../selectors/AuthSelectors';
import { selectorRestaurantId } from '../../selectors/RestaurantSelectors';
import { queryClient } from '../../shared/queryClient';
import { reserveState } from '../../config/constants';
import { getActiveInPeriodQueryKey } from '../../_FSD/entities/booking';
import moment, { Moment } from 'moment';

export function* refetchActiveBookingsQueries(_action?: any) {
  const userId = yield select(selectorAuthUserId);
  const restaurantId = yield select(selectorRestaurantId);
  if (!userId || !restaurantId) {
    return;
  }

  let from: Moment | undefined;
  if (_action?.type?.startsWith('WEBSOCKET_')) {
    if (
      [reserveState.PATCHING, reserveState.CANCELING].includes(
        _action?.event?.payload?.bookingState,
      )
    ) {
      return;
    }

    if (_action?.date) {
      const _from = moment(_action?.date);
      if (_from.isValid()) {
        from = _from.startOf('day');
      }
    }

    if (_action?.event?.payload?.date) {
      let _from = moment(_action?.event?.payload?.date);
      if (_from.isValid()) {
        _from = _from.startOf('day');
        from = from ? moment.min([from, _from]) : _from;
      }
    }
  }

  const queryKey = getActiveInPeriodQueryKey(userId, restaurantId, from);
  yield call(queryClient.refetchQueries.bind(queryClient), { queryKey });
}
